import {
  Button,
  formatDecimal,
  ListContainer,
  ListContext,
  NoData,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useTheme,
} from "@compass/core";
import { Permission, PermissionAction, StudentGpa } from "generated/openApi";
import { useRouter } from "hooks";
import "moment-timezone";
import { studentGpaPageRoute } from "pages/students/student-gpas/StudentGpaPage/StudentGpaPage";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";

export const Gpas = (props: {
  studentId: number;
  year: number | undefined;
  gpas: StudentGpa[];
  onGetList: () => void;
}) => {
  const ROOT_PERMISSION: Permission = Permission.StudentGpa;
  const navigate = useNavigate();
  const theme = useTheme();
  const { matchTemplatePath } = useRouter();

  return (
    <>
      <ListContainer
        header={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">GPA</Typography>

            <Stack direction="row" alignItems="center" spacing="sm">
              {isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && (
                <Button
                  variant="text"
                  onClick={() => {
                    navigate({
                      pathname: studentGpaPageRoute.getPath({ id: 0, crudMode: "edit", screenType: "dialog" }),
                      search: studentGpaPageRoute.getOptionalParams?.({
                        studentId: props.studentId,
                        schoolYear: props.year,
                      }),
                    });
                  }}
                  sx={{ minWidth: "auto" }}
                >
                  + New
                </Button>
              )}
            </Stack>
          </Stack>
        }
        tableContainer={
          <TableContainer>
            <Table stickyHeader>
              <TableBody>
                {props.gpas.map((gpa) => (
                  <TableRow
                    key={gpa.id}
                    onClick={() =>
                      navigate({
                        pathname: studentGpaPageRoute.getPath({
                          id: gpa.id,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                      })
                    }
                  >
                    <TableCell>
                      <Stack>
                        <Typography>
                          {gpa.termType?.name} {gpa.termNumber}
                        </Typography>
                        <Typography variant="caption">{gpa.school?.name}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell align="right">
                      {gpa.gpa ? (
                        <Typography>{formatDecimal(gpa.gpa)}</Typography>
                      ) : (
                        <Typography color={theme.palette.warning.main}>{gpa.reasonMissing?.name}</Typography>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      {matchTemplatePath(studentGpaPageRoute.templatePath) && (
        <ListContext.Provider value={{ loadList: () => props.onGetList() }}>
          <Outlet />
        </ListContext.Provider>
      )}
    </>
  );
};
